import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './../css/master.css';
import './../css/po.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const { IMG_TYPES } = require('./imgType');

var lstMonthSpan = [];
var httpURL = '';
var queryString = require('querystring');
var lstPo = [];
var lstPoDesign = [];
var totalLength = 0;
var totalCapability = 0;
var totalUsage = 0;
var lstPoMachineAvalability = [];
var lstPoMachine = [];
var sortVal = "";
var flg = false;
var COL_PO_QUOTEID = 'td:eq(0)';
var COL_PO_POID = 'td:eq(1)';
var COL_PO_PONO = 'td:eq(2)';
var COL_PO_ASIGNDATE = 'td:eq(3)';
var COL_PO_ACCEPTDATE = 'td:eq(4)';

var COL_POD_DESIGNID = 'td:eq(0)';
var COL_POD_DESIGNNOCOLOR = 'td:eq(1)';
var COL_POD_IMAGE = 'td:eq(2)';
var COL_POD_CSDELIVERYDT = 'td:eq(3)';
var COL_POD_LENGTH = 'td:eq(4)';
var COL_POD_WIDTH = 'td:eq(5)';
var COL_POD_CONSTRUCTION = 'td:eq(6)';
var COL_POD_YARNCOUNT = 'td:eq(7)';
var COL_POD_QUALITY = 'td:eq(8)';
var COL_POD_RATE = 'td:eq(9)';
var COL_POD_COUNTERRATE = 'td:eq(10)';
var COL_POD_MOQ = 'td:eq(11)';
var COL_POD_MOR = 'td:eq(12)';
var COL_POD_NOTES = 'td:eq(13)';
var COL_POD_IPODESIGNID = 'td:eq(14)';

var COL_POA_MACHINETYPE = 'td:eq(0)';
var COL_POA_CAPACITY = 'td:eq(1)';
var COL_POA_COUNT = 'td:eq(2)';

var COL_POM_DESIGNID = 'td:eq(0)';
var COL_POM_DESIGNNOCOLOR = 'td:eq(1)';
var COL_POM_MACHINETYPEID = 'td:eq(2)';
var COL_POM_MACHINETYPE = 'td:eq(3)';
var COL_POM_CAPACITY = 'td:eq(4)';
var COL_POM_FROMDT = 'td:eq(5)';
var COL_POM_TODT = 'td:eq(6)';
var COL_POM_CAPABILITY = 'td:eq(7)';
var COL_POM_COUNT = 'td:eq(8)';
var COL_POM_IPODESIGNID = 'td:eq(9)';

class PO extends Component {
	constructor(props) {
		super(props);
		this.state = {
			po: [],
			poDesign: [],
			poAvalibility: [],
			poMachine: [],
			deliveryDate: null,
			minDate: new Date(),
			maxDate: null,
			endDate1: null,
			startDate1: null,
			endDate2: null,
			startDate2: null,
			loader: 'none',
			opacity: 1,
			width: '97.6%',
			width1: '96%',
			width2: '97.6%',
			width3: '96%',
			chkAccept:false,
			acceptRequired: false

		}
		this.handleStartDate1 = this.handleStartDate1.bind(this);
		this.handleEndDate1 = this.handleEndDate1.bind(this);
		this.handleStartDate2 = this.handleStartDate2.bind(this);
		this.handleEndDate2 = this.handleEndDate2.bind(this);
		this.getPoDesignDetails = this.getPoDesignDetails.bind(this);

	}

	handleStartDate1(date) {
		this.setState({
			startDate1: date,
		});
	}
	handleEndDate1(date) {
		this.setState({
			endDate1: date
		});
	}
	handleStartDate2(date) {
		this.setState({
			startDate2: date,
		});
	}
	handleEndDate2(date) {
		this.setState({
			endDate2: date
		});
	}

	hideSlider(e) {
		e.preventDefault();
		$('.cd-panel').removeClass('is-visible');
		$('.designPopup1').hide();
	}

	async componentDidMount() {

		var weaverId = sessionStorage.getItem('weaverId');
		await axiosInstance.post(httpURL + '/w/po/list',
			queryString.stringify({ 'weaverId': weaverId }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					po: response.data.lstPO,
				})
				lstPo = this.state.po;

				this.setPOTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}

	setAvailabilityTable = () => {
		$('#poAvailabilityTableBody tr').remove();
		$('#poAvailabilityTable thead tr').remove();
		var row2 = document.createElement('tr');
		var row3 = document.createElement('tr');

		for (var z = 0; z < lstMonthSpan.length; z++) {
			var month = lstMonthSpan[z].month;
			var span = lstMonthSpan[z].spanCols;
			var maxD = lstMonthSpan.spanCols;
			this.addTH(row2, span, month);
			this.addTH2(row3, span + lstMonthSpan[z].startDay - 1, lstMonthSpan[z].startDay);
		}

		$('#poAvailabilityTable thead').append(row2);
		$('#poAvailabilityTable thead').append(row3);
		$('#poMachineTableBody tr').remove();

		var typeTable = document.getElementById('poMachineTable');
		var typeTbody = document.getElementById('poMachineTableBody');
		var availabilityTable = document.getElementById('poAvailabilityTable');
		var availabilityTbody = document.getElementById('poAvailabilityTableBody');

		for (var i = 0; i < lstPoMachineAvalability.length; i++) {
			var machineTypeId = lstPoMachineAvalability[i].mtyId;
			var machineType = lstPoMachineAvalability[i].mty;
			var capacity = lstPoMachineAvalability[i].capacity;
			var count = lstPoMachineAvalability[i].count;
			var availability = lstPoMachineAvalability[i].availability;

			var row = document.createElement('tr');
			row.id = machineTypeId;
			var row1 = document.createElement('tr');
			/* row.onclick=(e)=>{    
				  $(row).addClass('selected').siblings().removeClass('selected');
				  var capacityvalue=$(row).find('td:eq(2)').text();
					var countvalue=$(row).find('td:eq(3)').text();
					var designId = $('#poDesignTableBody tr.selected').find(COL_POD_DESIGNID).text();
					if(designId == ''){
						toast.warning('Please select design first');
						return false;
					}else{
						$('.onaddPopup').show();
						$('.main, .cd-panel').addClass('addOpacity');
					}
				
					$('#machineCmb').val($(row).find('td:eq(0)').text());
					$('#capacity').val(capacityvalue);
					$('#count').val(countvalue);
				
			var fromDate 		= $('#inp_fromDatePopup').val();
					var toDate 			= $('#inp_toDatePopup').val();
					var designId		= $('#poDesignTableBody tr.selected').find(COL_POD_DESIGNID).text();
					var designNoColor	= $('#poDesignTableBody tr.selected').find(COL_POD_DESIGNNOCOLOR).text();
					
					$('#machineTableBody tr').each((i, e)=>{
						var machineTypeId = $(e).find('td:eq(0)').text();
						var machineType = $(e).find('td:eq(1)').text();
						var capacity = $(e).find('td:eq(2)').text();
						var count = $(e).find('td:eq(3)').text();
					
						var diff  = (this.state.endDate2 - this.state.startDate2)/(1000*60*60*24);
					
						if(diff < 0){
							toast.warning('End Date should be greater than from start date');
							return false;
						}
				
						var capability 		= capacity * (diff + 1);
						lstPoMachine.push({'designId':designId, 'count':count, 'designNoColor':designNoColor, 'machineTypeId':machineTypeId, 'machineType':machineType, 'capacity':capacity, 'fromDt':fromDate, 'toDt':toDate, 'capability':capability});
						this.setPoMachineTable();
						this.closePoPup();
					});
			} */

			for (var j = 0; j < availability.length; j++) {
				this.addTD1(row1, availability[j], count, '');
				availabilityTbody.append(row1);
			}
			this.addTD(row, machineTypeId, 'no-display');
			this.addTD(row, machineType, '');
			this.addTD(row, capacity, 'txtright');
			this.addTD(row, count, 'txtright');
			//this.addTDCbx(row, 'cbx'+machineType, 'text-center');

			typeTbody.append(row);
			availabilityTable.append(availabilityTbody);
		}
		typeTable.append(typeTbody);
	}


	addTD1(row, val, count, classname) {
		var cell = document.createElement('td');
		cell.style.height = "32.4px !important";
		//cell.colSpan = 2;
		if (val == count) {
			cell.style.backgroundColor = 'rgb(223, 253, 172)';
			cell.className += classname;
		} else if (val == 0) {
			cell.style.backgroundColor = '#ddd';
			cell.className += classname;
			var icon = document.createElement('span');
			icon.className = "glyphicon glyphicon-remove text-muted";
			cell.append(icon);
		} else {
			cell.style.backgroundColor = '#fff';
			cell.className += classname;
			var text = document.createTextNode(val);
			cell.append(text);
		}
		row.append(cell);
	}

	addTH(row, span, val) {
		var cell = document.createElement('th');
		cell.style.textAlign = 'center';
		cell.colSpan = span;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	addTH2(row, maxdate, startdate) {
		for (var m = startdate; m <= maxdate; m++) {
			var cell = document.createElement('th');
			//cell.style.width='10px';
			var text = document.createTextNode(m);
			//cell.colSpan = 2;
			cell.append(text);
			row.append(cell)
		}
	}

	handleResize = () => {
		var width = ($('.tableLayout1').parent().width()) - 17;
		var width1 = ($('.tableLayout2').parent().width()) - 17;
		var width2 = ($('.tableLayout3').parent().width()) - 17;
		var width3 = ($('.tableLayout4').parent().width()) - 17;
		this.setState({ width: width, width1: width1, width2: width2, width3: width3 });
	}

	setPOTable = () => {
		$('#poTableBody tr').remove();
		var table = document.getElementById('poTable');
		var tbody = document.getElementById('poTableBody');
		var filterPoNo = $('#poNo').val().trim().toLowerCase();

		for (var i = 0; i < lstPo.length; i++) {
			var quoteId = lstPo[i].quoteId;
			var ipoId = lstPo[i].ipoId;
			var ipoNo = lstPo[i].ipoNo;
			var assignDt = lstPo[i].assignedDate === null ? '-' : lstPo[i].assignedDate;
			var acceptDt = lstPo[i].acceptedDate === null ? '-' : lstPo[i].acceptedDate;

			var row = document.createElement('tr');
			row.id = 'poTable' + ipoId;
			/*row.onclick =(e)=>{
				$(e.path[1]).addClass('selected').siblings().removeClass('selected');
				//this.getPoDesignDetails();
				$('#designColorCmb').val('0');
				$('#inp_totalLength').val('');
				$('#comment').val('');
				$('#designImageDiv').empty();
			}*/

			if (ipoNo.toLowerCase().indexOf(filterPoNo) === -1)
				continue;

			this.addTD(row, quoteId, 'text-right');
			this.addTD(row, ipoId, 'no-display');
			this.addTD(row, ipoNo, '');
			this.addTD(row, assignDt, 'text-center');
			this.addTD(row, acceptDt, 'text-center');
			this.addTDEdit(row, 'glyphicon glyphicon-option-vertical', 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	addTDEdit(row, val, classname) {
		var cell = document.createElement('td');
		var span = document.createElement('span');
		cell.className = classname;
		span.className = val;
		span.style.position = 'relative';
		span.style.cursor = 'pointer';

		var ul = document.createElement('ul');
		ul.className = 'ulStyle1';
		var li1 = document.createElement('li');
		var li2 = document.createElement('li');
		// var li3 = document.createElement('li');

		li1.innerHTML = 'Accept Order';
		li2.innerHTML = 'Update Status';
		// li3.innerHTML = 'Progress';

		li1.onclick = () => {
			$('.cd-panel').addClass('is-visible');
			$('#acceptOrder').show().siblings('#updateStatus,#progress').hide();
			$('#acceptOrderDtls').show().siblings().hide();
			$('.designPopup1').css("display", "block");
			var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
			var ipoNo = $('#poTableBody tr.selected').find(COL_PO_PONO).text();
			var assignDt = $('#poTableBody tr.selected').find(COL_PO_ASIGNDATE).text();
			var acceptDt = $('#poTableBody tr.selected').find(COL_PO_ACCEPTDATE).text();

			if (acceptDt == "") {
				$('#saveMachine').attr('disabled', false);
				$('#acceprOrder').attr('disabled', false);
			}
			else {
				$('#saveMachine').attr('disabled', true);
				$('#acceprOrder').attr('disabled', true);
			}

			this.getPoDesignDetails(ipoId, ipoNo, assignDt);
			//this.getPoMachineAvalibity(ipoId);
			setTimeout(() => { this.getPoMachine(ipoId) }, 1000);
			this.handleResize();
		};

		/*li2.onclick = ()=>{
			$('.cd-panel').addClass('is-visible');
			$('#updateStatus').show().siblings('#acceptOrder,#progress').hide();
			var ipoId 	= $('#buyerPOTableBody tr.selected').find(COL_PO_POID).text();
		};
		
		li3.onclick = ()=>{
			$('.cd-panel').addClass('is-visible');
			$('#progress').show().siblings('#acceptOrder,#updateStatus').hide();
			var ipoId 	= $('#buyerPOTableBody tr.selected').find(COL_PO_POID).text();
		};*/

		ul.append(li1);
		ul.append(li2);
		//ul.append(li3);

		span.onclick = (e) => {
			$(ul).toggle();
			$(e.target.closest('tr')).siblings().find('span ul').hide();
			$(e.target.closest('tr')).addClass('selected').siblings().removeClass('selected');
		};

		span.append(ul);
		cell.append(span);
		row.append(cell);
	}

	addTDPen(row, val, classname) {
		var cell = document.createElement('td');
		var span = document.createElement('span');
		cell.className = classname;
		span.className = val;
		span.style.cursor = 'pointer';

		span.onclick = (e) => {
			$(e.target.closest('tr')).addClass('selected').siblings().removeClass('selected');
			flg = true;
			this.openPoPup();
			this.setPopupForm();
		};

		cell.append(span);
		row.append(cell);
	}

	getIdxStaff(id) {
		for (var i = 0; i < lstPoMachine.length; i++) {
			if (lstPoMachine[i].machineTypeId == id) {
				return i;
			}
		}
		return -1;
	}

	addTDImage(row, val, classname) {
		var date = new Date();
		var cell = document.createElement('td');
		cell.className = classname;
		var img = document.createElement('img');
		img.style.width = '20px';
		img.style.height = '20px';

		if (val == '') {
			img.src = require("../images/logo.png");
		} else if (val != null) {
			img.src = window.httpURL + "/a/mst/dsn/getImage?img=" + val + '&imgType=' + IMG_TYPES.THUMB;
		} else {
			img.src = require("../images/logo.png");
		}
		cell.append(img);
		row.append(cell);
	}

	addTDNotes(row, val, classname) {
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		//cell.style.position =  'relative'; 
		cell.style.whiteSpace = 'nowrap';
		cell.style.overflow = 'hidden';
		cell.style.textOverflow = 'ellipsis';
		cell.dataset.title = val;
		cell.addEventListener('mousemove', this.openNotes);
		cell.append(text);
		row.append(cell);
	}

	openNotes = (e) => {
		//var val = $(e.target).text();
		$('[data-title]').after().css({ 'top': e.target.offsetTop });
	}

	getPoDesignDetails(ipoId, ipoNo, assignDt) {
		var weaverId = sessionStorage.getItem('weaverId');
		var wvrPO = { 'weaverId': parseInt(weaverId), 'ipoId': parseInt(ipoId) };

		axiosInstance.post(httpURL + '/w/po/dtls',
			queryString.stringify({ 'WvrPO': JSON.stringify(wvrPO) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				totalLength = response.data.totalOrderLength;

				this.setState({
					poDesign: response.data.lstPODesign,
				});
				lstPoDesign = this.state.poDesign;
				$('#inp_poId').val(ipoId);
				$('#inp_poNo').val(ipoNo);
				$('#inp_assignDate').val(assignDt);
				this.setPoDesignTable();

				var startDate = assignDt.split('-').reverse().join();
				startDate = startDate.replace(/,/g, '-');
				startDate = new Date(startDate);
				startDate = startDate.setDate(startDate.getDate() + 30);

				this.setState({
					startDate1: new Date(startDate),
				}, () => {
					var endDate = new Date(startDate);
					endDate = endDate.setDate(endDate.getDate() + 89);
					this.setState({
						endDate1: new Date(endDate),
					});
				});

				this.getPoMachineAvalibity();
			} else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	getPoMachineAvalibity = () => {
		var ipoId = $('#inp_poId').val();
		var weaverId = sessionStorage.getItem('weaverId');
		var fromDate = $('#inp_fromDate').val();
		var toDate = $('#inp_toDate').val();
		//var wvrPO = {'weaverId': parseInt(weaverId), 'ipoId':parseInt(ipoId)};

		axiosInstance.post(httpURL + '/w/po/listavailability',
			queryString.stringify({ 'weaverId': weaverId, 'ipoId': ipoId, 'startDt': fromDate, 'endDt': toDate }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				lstMonthSpan = response.data.lstMonthSpan;
				lstPoMachineAvalability = response.data.lstAvailability;
				this.setAvailabilityTable();
				this.fillMachineCmb();
			} else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	getPoMachine = (ipoId) => {
		var weaverId = sessionStorage.getItem('weaverId');
		var wvrPO = { 'weaverId': parseInt(weaverId), 'ipoId': parseInt(ipoId) };

		axiosInstance.post(httpURL + '/w/po/listpomachines',
			queryString.stringify({ "totalOrderLength": totalLength, 'WvrPO': JSON.stringify(wvrPO) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				totalCapability = response.data.totalCapability;
				totalUsage = response.data.usage;
				this.setState({
					poMachine: response.data.lstPOMachines,
				});
				lstPoMachine = this.state.poMachine;
				this.setPoMachineTable();
			}
			else {
				toast.success(response.data.SvcMsg);
				if (response.data.SvcMsg == 'No POMachines Added Yet') {
					lstPoMachine = [];
					this.setPoMachineTable();
				}
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setPoDesignTable = () => {
		$('#poDesignTableBody tr').remove();
		var table = document.getElementById('poDesignTable');
		var tbody = document.getElementById('poDesignTableBody');
		//var filterDesignColor 	= $('#designColor').val().toLowerCase();

		for (var i = 0; i < lstPoDesign.length; i++) {
			var id = lstPoDesign[i].designId;
			var designColor = lstPoDesign[i].designNoColor;
			var designImage = lstPoDesign[i].img;
			var csDeliveryDt = lstPoDesign[i].deliveryDate;
			var length = lstPoDesign[i].length == 0 ? '' : lstPoDesign[i].length;
			var width = lstPoDesign[i].width == null ? '' : lstPoDesign[i].width;
			var construction = lstPoDesign[i].construction;
			var yarnCount = lstPoDesign[i].yarnCount;
			var quality = lstPoDesign[i].quality;
			var rate = lstPoDesign[i].rate == 0 ? '' : lstPoDesign[i].rate;
			var counterRate = lstPoDesign[i].counterRate == 0 ? '' : lstPoDesign[i].counterRate;
			if ( this.state.acceptRequired == false && counterRate != '' ){
				this.setState({acceptRequired: true});
			}

			var moq = lstPoDesign[i].moQ == 0 ? '' : lstPoDesign[i].moQ;
			var mor = lstPoDesign[i].moR == 0 ? '' : lstPoDesign[i].moR;
			var notes = lstPoDesign[i].notes;
			var ipoDesignId = lstPoDesign[i].ipoDesignId;

			var row = document.createElement('tr');
			row.id = id;

			row.onclick = (e) => {
				$($(e.target).closest('tr')).addClass('selected').siblings().removeClass('selected');
				var designId = $(e.target).closest('tr').find(COL_POD_DESIGNID).text();
				$('#poDesignMachineTableBody tr').each(function () {
					if ($(this).find(COL_POM_DESIGNID).text() == designId) {
						$(this).addClass('selected').siblings().removeClass('selected');
					} else {
						$(this).removeClass('selected');
					}
				});
			}

			//if(designColor.toLowerCase().indexOf(filterDesignColor) == -1)
			//continue;

			this.addTD(row, id, '');
			this.addTD(row, designColor, '');
			this.addTDImage(row, designImage, 'text-center');
			this.addTD(row, csDeliveryDt, 'text-center');
			this.addTD(row, length, 'text-right');
			this.addTD(row, width, '');
			this.addTD(row, construction, '');
			this.addTD(row, yarnCount, '');
			this.addTD(row, quality, '');
			this.addTD(row, rate, 'text-right');
			this.addTD(row, counterRate, 'text-right');
			this.addTD(row, moq, 'text-right');
			this.addTD(row, mor, 'text-right');
			this.addTDNotes(row, notes, '');
			this.addTD(row, ipoDesignId, 'no-display');

			tbody.append(row);
		}
		table.append(tbody);
	}

	fillMachineCmb = () => {
		$('#machineCmb').empty();
		$('#machineCmb').prepend($("<option> </option>").val(0).html('Machine Type'));
		for (var i = 0; i < lstPoMachineAvalability.length; i++) {
			var machineTypeId = lstPoMachineAvalability[i].mtyId;
			var machineType = lstPoMachineAvalability[i].mty;
			$('#machineCmb').append($("<option> </option>").val(machineTypeId).html(machineType));
		}
	}

	setPoMachineTable = () => {
		$('#poDesignMachineTableBody tr').remove();
		var table = document.getElementById('poDesignMachineTable');
		var tbody = document.getElementById('poDesignMachineTableBody');
		//var filterDesignColor 	= $('#designColor').val().toLowerCase();

		for (var i = 0; i < lstPoMachine.length; i++) {
			var objPoMachine = lstPoMachine[i];
			var id = objPoMachine.designId;
			var designColor = objPoMachine.designNoColor;
			var machineTypeId = objPoMachine.machineTypeId;
			var machineType = objPoMachine.machineType;
			var capacity = objPoMachine.capacity;
			var count = objPoMachine.count;
			var fromDate = objPoMachine.fromDt;
			var toDate = objPoMachine.toDt;
			var capability = objPoMachine.capability;
			var ipoDesignId = objPoMachine.ipoDesignId;

			var row = document.createElement('tr');
			row.id = id;
			row.setAttribute("ipoWorkId", objPoMachine.ipoWorkId);
			row.onclick = (e) => {
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			}

			//if(designColor.toLowerCase().indexOf(filterDesignColor) == -1)
			//continue;

			this.addTD(row, id, '');
			this.addTD(row, designColor, '');
			this.addTD(row, machineTypeId, 'no-display');
			this.addTD(row, machineType, '');
			this.addTD(row, capacity, 'text-right');
			this.addTD(row, fromDate, 'text-center');
			this.addTD(row, toDate, 'text-center');
			this.addTD(row, capability, 'text-right');
			this.addTD(row, count, 'no-display');
			this.addTD(row, ipoDesignId, 'no-display');
			this.addTDPen(row, 'glyphicon glyphicon-pencil', 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	machineSelectChange = (e) => {
		var machineTypeId = $(e.target).find('option:selected').val();
		var capacity = this.getCapacityById(machineTypeId);
		if (capacity != -1) {
			$('#capacity').val(capacity);
		} else {
			$('#capacity').val('');
		}
	}

	getCapacityById = (id) => {
		for (var i = 0; i < lstPoMachineAvalability.length; i++) {
			if (lstPoMachineAvalability[i].mtyId == id) {
				return lstPoMachineAvalability[i].capacity;
			}
		}
		return -1;
	}
	/* unused function */
	handlePopupSave = () => {
		var machineTypeId = $('#machineCmb').find('option:selected').val();
		var machineType = $('#machineCmb').find('option:selected').text();
		var capacity = $('#capacity').val();
		var count = $('#count').val();
		var fromDate = $('#inp_fromDatePopup').val();
		var toDate = $('#inp_toDatePopup').val();
		var designId = $('#poDesignTableBody tr.selected').find(COL_POD_DESIGNID).text();
		var designNoColor = $('#poDesignTableBody tr.selected').find(COL_POD_DESIGNNOCOLOR).text();
		var ipoDesignId = $('#poDesignTableBody tr.selected').find(COL_POD_IPODESIGNID).text();
		var diff = (this.state.endDate2 - this.state.startDate2) / (1000 * 60 * 60 * 24);
		if (diff < 0) {
			toast.warning('End Date should be greater than from start date');
			return false;
		}
		if (count == "") {
			toast.warning('Please add count for the machine !');
			return false;
		}
		if (fromDate == "") {
			toast.warning('Please select From Date for the machine !');
			return false;
		}

		var capability = count * capacity * (diff + 1);

		if (flg) {
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_MACHINETYPEID).text(machineTypeId);
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_MACHINETYPE).text(machineType);
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_CAPACITY).text(capacity);
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_COUNT).text(count);
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_FROMDT).text(fromDate);
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_TODT).text(toDate);
			$('#poDesignMachineTableBody tr.selected').find(COL_POM_CAPABILITY).text(capability);
		} else {
			lstPoMachine.push({ 'designId': designId, 'ipoDesignId': ipoDesignId, 'count': count, 'designNoColor': designNoColor, 'machineTypeId': machineTypeId, 'machineType': machineType, 'capacity': capacity, 'fromDt': fromDate, 'toDt': toDate, 'capability': capability });
			this.setPoMachineTable();
		}
		this.closePoPup();
		/*var x = this.checkExist(designNoColor,designId);
				if(x != -1){ 
					
					//lstPoMachine[x].push({'designId':designId, 'count':count, 'designNoColor':designNoColor, 'machineTypeId':machineTypeId, 'machineType':machineType, 'capacity':capacity, 'fromDt':fromDate, 'toDt':toDate, 'capability':capability});
				}else{
					lstPoMachine[x].count = count;
					lstPoMachine[x].designNoColor = designNoColor;
					lstPoMachine[x].machineType = machineType;
					lstPoMachine[x].machineTypeId = machineTypeId;
					lstPoMachine[x].capacity = capacity;
					lstPoMachine[x].fromDt = fromDate;
					lstPoMachine[x].toDt = toDate;
					lstPoMachine[x].designId = designId;
					lstPoMachine[x].capability = capability;
				}
				this.setPoMachineTable();
			this.closePoPup();*/
	}

	/*checkExist(designNoColor,designId){
		for(var i=0; i<lstPoMachine.length; i++){
			if(lstPoMachine[i].designNoColor == designNoColor && lstPoMachine[i].designId == designId){
				  return i;
			}
		}
		return -1;
	}*/
	saveOrder = () => {
		var weaverId = sessionStorage.getItem('weaverId');
		var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
		console.log("ipoId = " + ipoId);
		var count = $('#poDesignMachineTableBody tr').find(COL_POA_COUNT).text();
		console.log("count = " + count);

		if ( this.state.acceptRequired && !this.state.chkAccept ){
			toast.warning('Please accept ChandraSilk counter rates');
			return false;
		}
		if (count == '') {
			toast.warning('Please select machine first');
			return false;
		} else {
			axiosInstance.post(httpURL + '/w/po/accept',
				queryString.stringify({ 'ipoId': parseInt(ipoId), 'wvrId': weaverId }), { withCredentials: true }
			).then((response) => {
				if (response.data.SvcStatus === "Success") {
					toast.success(response.data.SvcMsg);
					var acptdt = response.data.acceptedDate;
					$('#poTableBody tr.selected').find(COL_PO_ACCEPTDATE).text(acptdt);
					$('#saveMachine').attr('disabled', true);
					$('#acceprOrder').attr('disabled', true);
					this.getPoMachine(ipoId);
				}
				else {
					toast.error(response.data.SvcMsg);
				}
				this.setState({ loader: 'none', opacity: 1 });
			}).catch((e) => {
				toast.error("Service failed " + e);
			});
		}
	}

	saveMachine = () => {
		var WvrPOMachines = {};
		var lstPOMachines = [];
		var weaverId = sessionStorage.getItem('weaverId');
		var designId = '';
		var machineType = '', machineTypeId = '';
		var ipoDesignId = '';
		var flag = true;
		var $designMcTableRow = $('#poDesignMachineTableBody tr.selected');
		var $row = $('#poDesignTableBody tr.selected');
		designId = $row.find(COL_POD_DESIGNID).text();
		machineTypeId = $('#machineCmb').find('option:selected').val();
		machineType = $('#machineCmb').find('option:selected').text();
		ipoDesignId = $row.find(COL_POD_IPODESIGNID).text();
		var count = $('#count').val();
		var fromDt = $('#inp_fromDatePopup').val();
		var toDt = $('#inp_toDatePopup').val();
		var ipoWorkId = flg ? $designMcTableRow.attr("ipoWorkId") : 0;
		var capacity = $('#capacity').val();
		var diff = (this.state.endDate2 - this.state.startDate2) / (1000 * 60 * 60 * 24);
		if (machineType == null || machineType == 'Machine Type') {
			toast.warning('Machine Type is mandatory.');
			return false;
		}
		if (diff < 0) {
			toast.warning('End Date should be greater than Start Date');
			return false;
		}
		if (count == "") {
			toast.warning('Please add count for the machine !');
			return false;
		}
		if (fromDt == "") {
			toast.warning('Please select From Date for the machine !');
			return false;
		}

		var capability = count * capacity * (diff + 1);

		console.log("ipoWorkId = " + ipoWorkId);
		var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
		var objIpoWork = {
			'ipoWorkId': ipoWorkId,
			'ipoId': ipoId,
			'wvrId': weaverId,
			'ipoDesignId': ipoDesignId,
			'designId': designId,
			'machineTypeId': machineTypeId,
			'count': count,
			'fromDt': fromDt,
			'toDt': toDt,
		};

		axiosInstance.post(httpURL + '/w/po/save_machine',
			queryString.stringify({ 'wvrPoSaveMachine': JSON.stringify(objIpoWork) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				toast.success(response.data.SvcMsg);

				if (flg) {
					$designMcTableRow.find(COL_POM_MACHINETYPEID).text(machineTypeId);
					$designMcTableRow.find(COL_POM_MACHINETYPE).text(machineType);
					$designMcTableRow.find(COL_POM_CAPACITY).text(capacity);
					$designMcTableRow.find(COL_POM_COUNT).text(count);
					$designMcTableRow.find(COL_POM_FROMDT).text(fromDt);
					$designMcTableRow.find(COL_POM_TODT).text(toDt);
					$designMcTableRow.find(COL_POM_CAPABILITY).text(capability);
				} else {
					this.getPoMachine(ipoId);
				}
				this.closePoPup();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	getIdxMachine(machineTypeId, designId) {
		for (var i = 0; i < lstPoMachine.length; i++) {
			if (lstPoMachine[i].machineTypeId == machineTypeId && lstPoMachine[i].designId == designId) {
				return i;
			}
		}
		return -1;
	}

	refresh = () => {
		var ipoId = $('#poTableBody tr.selected').find(COL_PO_POID).text();
		var ipoNo = $('#poTableBody tr.selected').find(COL_PO_PONO).text();
		var assignDt = $('#poTableBody tr.selected').find(COL_PO_ASIGNDATE).text();
		this.getPoMachineAvalibity();
		//this.getPoDesignDetails(ipoId, ipoNo, assignDt);
		this.getPoMachine(ipoId);
	}

	sortAscByPo = () => {
		if (sortVal != 'aspo') {
			sortVal = 'aspo';
			$("#poAsDtIcon").css("color", "gray");
			$("#poDsDtIcon").css("color", "#111");
			$("#assignAsDtIcon").css("color", "#111");
			$("#assignDsDtIcon").css("color", "#111");
			$("#acceptAsDtIcon").css("color", "#111");
			$("#acceptDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].ipoNo;
				for (var j = i + 1; j < lstPo.length; j++) {
					val2 = lstPo[j].ipoNo;
					if (val1 > val2) {
						var tmp = lstPo[j];
						lstPo[j] = lstPo[i];
						lstPo[i] = tmp;
						val1 = lstPo[i].bpoNo;
					}
				}
			}
			this.setPOTable();
		}
	}

	sortDesByPo = () => {
		if (sortVal != 'dspo') {
			sortVal = 'dspo';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "gray");
			$("#deliveryAsDtIcon").css("color", "#111");
			$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].bpoNo;
				for (var j = i + 1; j < lstPo.length; j++) {
					val2 = lstPo[j].bpoNo;
					if (val1 < val2) {
						var tmp = lstPo[j];
						lstPo[j] = lstPo[i];
						lstPo[i] = tmp;
						val1 = lstPo[i].bpoNo;
					}
				}
			}
			this.setPOTable();
		}
	}

	sortAscByAssign = () => {
		if (sortVal != 'asdel') {
			sortVal = 'asdel';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#deliveryAsDtIcon").css("color", "gray");
			$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].deliveryDt;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
					for (var j = i + 1; j < lstPo.length; j++) {
						val2 = lstPo[j].deliveryDt;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 > dt2) {
								var tmp = lstPo[j];
								lstPo[j] = lstPo[i];
								lstPo[i] = tmp;
								val1 = lstPo[i].deliveryDt;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setPOTable();
		}
	}

	sortDesByDelivery = () => {
		if (sortVal != 'dsdel') {
			sortVal = 'dsdel';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#deliveryAsDtIcon").css("color", "#111");
			$("#deliveryDsDtIcon").css("color", "gray");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstPo.length - 1; i++) {
				val1 = lstPo[i].deliveryDt;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);

					for (var j = i + 1; j < lstPo.length; j++) {
						val2 = lstPo[j].deliveryDt;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 < dt2) {
								var tmp = lstPo[j];
								lstPo[j] = lstPo[i];
								lstPo[i] = tmp;
								val1 = lstPo[i].deliveryDt;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setPOTable();
		}
	}

	setPopupForm = () => {
		var machineTypeId = $('#poDesignMachineTableBody tr.selected').find(COL_POM_MACHINETYPEID).text();
		var capacity = $('#poDesignMachineTableBody tr.selected').find(COL_POM_CAPACITY).text();
		var count = $('#poDesignMachineTableBody tr.selected').find(COL_POM_COUNT).text();
		var fromDate = $('#poDesignMachineTableBody tr.selected').find(COL_POM_FROMDT).text();
		var toDate = $('#poDesignMachineTableBody tr.selected').find(COL_POM_TODT).text();

		$('#machineCmb').val(machineTypeId);
		$('#capacity').val(capacity);
		$('#count').val(count);
		var startDate = fromDate.split('-').reverse().join();
		startDate = new Date(startDate);
		var endDate = toDate.split('-').reverse().join();
		endDate = new Date(endDate);
		this.setState({
			startDate2: new Date(startDate),
			endDate2: new Date(endDate),
		});
	}

	openPoPup = () => {
		var designId = $('#poDesignTableBody tr.selected').find(COL_POD_DESIGNID).text();
		if (designId == '' && !flg) {
			toast.warning('Please select design first');
			return false;
		} else {
			$('.onaddPopup').show();
			$('.main, .cd-panel').addClass('addOpacity');
			if (!flg) {
				$('#machineCmb').val(0);
				$('#capacity').val('');
				$('#count').val('');
				this.setState({
					startDate2: null,
					endDate2: null,
				});
			}
		}
	}

	closePoPup = (e) => {
		$('.onaddPopup').hide();
		$('.main, .cd-panel').removeClass('addOpacity');
		flg = false;
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<WeaverHeader />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div className="main">
					<div className="container-fluid">
						<div className="col-sm-6 col-centered">
							<div className="col-sm-12 padding-remove">
								<table className="tableLayout1" style={{ width: this.state.width }}>
									<thead>
										<tr>
											<th style={{ width: 30 }}>Quote Id</th>
											<th style={{ width: 50, display: 'none' }}>PO Id</th>
											<th style={{ width: 50 }}>
												<div style={{ float: 'left', width: '80%' }}>
													<input type="text" onChange={this.setPOTable} className="form-control inp-search" id="poNo" placeholder="PO No." />
												</div>
												<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
													<div className="assending">
														<span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</th>
											<th style={{ width: 50, textAlign: 'left' }}>
												<div style={{ width: '90%', marginLeft: '5%' }}>
													<div className="dateLabel">Assign Date</div>
													<div className="sortIcon">
														<div className="assending">
															<span id="assignAsDtIcon" onClick={this.sortAscByAssign} className="glyphicon glyphicon-triangle-top"></span>
														</div>
														<div className="desending">
															<span id="assignDsDtIcon" onClick={this.sortDesByAssign} className="glyphicon glyphicon-triangle-bottom"></span>
														</div>
													</div>
												</div>
											</th>
											<th style={{ width: 50, textAlign: 'left' }}>
												<div style={{ width: '90%', marginLeft: '5%' }}>
													<div className="dateLabel">Accept Date</div>
													<div className="sortIcon">
														<div className="assending">
															<span id="acceptAsDtIcon" onClick={this.sortAscByAccept} className="glyphicon glyphicon-triangle-top"></span>
														</div>
														<div className="desending">
															<span id="acceptDsDtIcon" onClick={this.sortDesByAccept} className="glyphicon glyphicon-triangle-bottom"></span>
														</div>
													</div>
												</div>
											</th>
											<th style={{ width: 25 }}>Action</th>
										</tr>
									</thead>
								</table>
								<div className="col-sm-12 poTableDiv padding-remove">
									<table id="poTable" className="tableLayout">
										<colgroup>
											<col width="30" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="25" />
										</colgroup>
										<tbody id="poTableBody"></tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="designPopup1">
					<header style={{ width: "90%" }}>
						<h3 id="acceptOrder">Accept Order</h3>
						<h3 id="updateStatus" style={{ display: 'none' }}>Update Status</h3>
						<h3 id="progress" style={{ display: 'none' }}>Progress</h3>
						<a href="#0" className="cd-panel-close glyphicon glyphicon-remove" onClick={this.hideSlider}>Close</a>
					</header>

					<div style={{ width: "90%" }}>
						<div className="cd-panel-content" id="poscreen">
							<div id="acceptOrderDtls">
								<div className="col-sm-12 padding-remove" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10, marginTop: 37 }}>
									<label htmlFor="inp_poNo">PO NO:</label>
									<div style={{ marginLeft: 5, width: 100 }}>
										<input type="text" style={{ height: 25, display: 'none' }} id="inp_poId" className='form-control' placeholder="PO Id" />
										<input type="text" style={{ height: 25 }} readOnly id="inp_poNo" className='form-control' placeholder="PO NO" />
									</div>
									<label style={{ marginLeft: 10 }} htmlFor="inp_assignDate">Assign Date:</label>
									<div style={{ marginLeft: 5, width: 100 }}>
										<input type="text" style={{ height: 25 }} readOnly id="inp_assignDate" className='form-control' placeholder="Assign Date" />
									</div>
								</div>
								<div className="col-sm-12 padding-remove">
									<table className="tableLayout2" style={{ width: this.state.width1 }}>
										<thead style={{ fontSize: 12 }}>
											<tr>
												<th style={{ width: 40 }}>Design Id</th>
												<th style={{ width: 60 }}>
													<input type="text" onChange={this.setPOTable} style={{ height: 25, fontSize: 12 }} className="form-control inp-search" id="filterDesignNoColor" placeholder="Design Color" />
												</th>
												<th style={{ width: 40 }}>Image</th>
												<th style={{ width: 60, textAlign: 'left' }}>
													<div style={{ width: '90%', marginLeft: '5%' }}>
														<div className="dateLabel">CS Del. Dt</div>
														<div className="sortIcon">
															<div className="assending">
																<span id="deliveryAsDtIcon" onClick={this.sortAscByDelivery} className="glyphicon glyphicon-triangle-top"></span>
															</div>
															<div className="desending">
																<span id="deliveryDsDtIcon" onClick={this.sortDesByDelivery} className="glyphicon glyphicon-triangle-bottom"></span>
															</div>
														</div>
													</div>
												</th>
												<th style={{ width: 40 }}>Length</th>
												<th style={{ width: 40 }}>Width</th>
												<th style={{ width: 50 }}>Construction</th>
												<th style={{ width: 50 }}>Yarn Count</th>
												<th style={{ width: 50 }}>Quality</th>
												<th style={{ width: 40 }}>Rate</th>
												<th style={{ width: 40 }}>CS Rate</th>
												<th style={{ width: 40 }}>MOQ</th>
												<th style={{ width: 40 }}>MOR</th>
												<th style={{ width: 40 }}>Note</th>
												<th style={{ width: 80, display: 'none' }}>IPO Design Id</th>
											</tr>
										</thead>
									</table>
									<div className="col-sm-12 poDesignTableDiv padding-remove" style={{ height: 78 }}>
										<table id="poDesignTable" className="tableLayout">
											<colgroup>
												<col width="40" />
												<col width="60" />
												<col width="40" />
												<col width="60" />
												<col width="40" />
												<col width="40" />
												<col width="50" />
												<col width="50" />
												<col width="50" />
												<col width="40" />
												<col width="40" />
												<col width="40" />
												<col width="40" />
												<col width="40" />
											</colgroup>
											<tbody id="poDesignTableBody"></tbody>
										</table>
									</div>
								</div>
								<div className="col-sm-12 padding-remove" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
									<label htmlFor="inp_fromDate">From Date:</label>
									<div style={{ marginLeft: 5, width: 100 }}>
										<DatePicker id="inp_fromDate"
											className='form-control text-center'
											placeholderText="From Date"
											selected={this.state.startDate1}
											onChange={this.handleStartDate1}
											dateFormat="dd-MM-yyyy"
											minDate={this.state.minDate}
											autoComplete='off'
										/>
									</div>
									<label style={{ marginLeft: 10 }} htmlFor="inp_toDate">To Date:</label>
									<div style={{ marginLeft: 5, width: 100 }}>
										<DatePicker id="inp_toDate"
											className='form-control text-center'
											placeholderText="To Date"
											selected={this.state.endDate1}
											onChange={this.handleEndDate1}
											dateFormat="dd-MM-yyyy"
											minDate={this.state.startDate1}
											maxDate={this.state.maxDate}
											autoComplete='off'
										/>
									</div>
									<button style={{ marginLeft: 20, height: 25, padding: '2px 12px' }} onClick={this.refresh} type="button" className="btn btn-warning">Refresh</button>
								</div>
								<div className="col-sm-12 padding-remove" style={{ height: 152, overflowY: 'scroll' }}>
									<div style={{ width: '20%' }} className="poMachineTableDiv col-sm-3 col-xs-3 padding-remove">
										<table id="poMachineTable" className="tableLayout">
											<thead style={{ fontSize: 12, height: 45 }}>
												<tr>
													<th style={{ width: 50, display: 'none' }}>Machine Id</th>
													<th style={{ width: 72 }}>Machine Type</th>
													<th style={{ width: 50 }}>Capacity</th>
													<th style={{ width: 40 }}>Count</th>
												</tr>
											</thead>
											<tbody id="poMachineTableBody" style={{ fontSize: 12 }}>
											</tbody>
										</table>
									</div>
									<div className="poAvailabilityTableDiv col-sm-9 col-xs-9 padding-remove" style={{ width: '80%' }}>
										<table id="poAvailabilityTable">
											<thead style={{ fontSize: 12, height: 45 }}>
												<tr>
													<th style={{ width: 200, textAlign: 'center' }}>Availability</th>
												</tr>
											</thead>
											<tbody id="poAvailabilityTableBody">
											</tbody>
										</table>
									</div>
								</div>

								<div className="col-sm-8 padding-remove">
									<table className="tableLayout4" style={{ width: this.state.width3 }}>
										<thead style={{ fontSize: 12 }}>
											<tr>
												<th style={{ width: 40 }}>Design Id</th>
												<th style={{ width: 60 }}>
													<input type="text" onChange={this.setPoDesignMachineTable} style={{ height: 25, fontSize: 12 }} className="form-control inp-search" id="filterDesignNoColor1" placeholder="Design Color" />
												</th>
												<th style={{ width: 60 }}>Machine Type</th>
												<th style={{ width: 40 }}>Capacity</th>
												<th style={{ width: 50, textAlign: 'left' }}>
													<div style={{ width: '90%', marginLeft: '5%' }}>
														<div className="dateLabel">From Date</div>
														<div className="sortIcon">
															<div className="assending">
																<span id="fromAsDtIcon" onClick={this.sortAscByFrom} className="glyphicon glyphicon-triangle-top"></span>
															</div>
															<div className="desending">
																<span id="fromDsDtIcon" onClick={this.sortDesByFrom} className="glyphicon glyphicon-triangle-bottom"></span>
															</div>
														</div>
													</div>
												</th>
												<th style={{ width: 50, textAlign: 'left' }}>
													<div style={{ width: '90%', marginLeft: '5%' }}>
														<div className="dateLabel">To Date</div>
														<div className="sortIcon">
															<div className="assending">
																<span id="toAsDtIcon" onClick={this.sortAscByTo} className="glyphicon glyphicon-triangle-top"></span>
															</div>
															<div className="desending">
																<span id="toDsDtIcon" onClick={this.sortDesByTo} className="glyphicon glyphicon-triangle-bottom"></span>
															</div>
														</div>
													</div>
												</th>
												<th style={{ width: 50 }}>Capability</th>
												<th style={{ width: 50, display: 'none' }}>Count</th>
												<th style={{ width: 40 }}>Action</th>
											</tr>
										</thead>
									</table>
									<div className="col-sm-12 poDesignMachineTableDiv padding-remove">
										<table id="poDesignMachineTable" className="tableLayout">
											<colgroup>
												<col width="40" />
												<col width="60" />
												<col width="60" />
												<col width="40" />
												<col width="50" />
												<col width="50" />
												<col width="50" />
												<col width="40" />
											</colgroup>
											<tbody id="poDesignMachineTableBody" style={{ fontSize: 12 }}></tbody>
										</table>
									</div>
								</div>
								<span type="" className="addIcon glyphicon glyphicon-plus-sign addMachine" onClick={this.openPoPup} style={{ height: 25, padding: 2 }}></span>
								<div className="col-sm-4">
									<div style={{ backgroundColor: '#fff', borderRadius: 10, padding: '25px 10px' }}>
										<div>
											<label className="text-right" style={{ width: 150, paddingRight: 20 }}>Total: </label>
											<span id="totalLength">{totalLength}/{totalCapability}</span>
										</div>
										<div>
											<label className="text-right" style={{ width: 150, paddingRight: 20 }}>Usage: </label>
											<span id="overUsage">{totalUsage}%</span>
										</div>
										{this.state.acceptRequired && 
										<div className='div_accept'>
											<input type='checkbox' checked={this.state.chkAccept} onChange={(e)=>this.setState({chkAccept:e.target.checked})}/>
											<span className="txt_accept" >
												I accept the counter rate offered by ChandraSilks.
												I acknowledge the fact that only after accepting the offer I will receive the PO in my mail box.
											</span>
										</div>
										}
										<div style={{ textAlign: 'center', marginTop: 10 }}>
											{/* <button type="text" className="btn btn-warning" id="saveMachine" onClick={this.saveMachine}>Save Machines</button> */}
											<button style={{ marginLeft: 10 }} type="text" className="btn btn-warning" onClick={this.saveOrder} id="acceprOrder">Accept Order</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="onaddPopup" style={{ display: 'none' }}>
					<div className="closeBtn" onClick={this.closePoPup.bind(this)}>
						<span style={{ position: 'absolute', color: '#fff', top: '18px', left: '18px' }} className="glyphicon glyphicon-remove">
						</span>
					</div>
					<div style={{ width: '100%', height: '100%' }}>
						<form id="addMachineForm" className="form-horizontal">
							<div className="form-group">
								<label className="control-label col-sm-5">Machine Type:</label>
								<div className="col-sm-7">
									<select className="form-control" id="machineCmb" onChange={this.machineSelectChange}></select>
								</div>
							</div>
							<div className="form-group">
								<label className="control-label col-sm-5">Capacity:</label>
								<div className="col-sm-7">
									<input type="text" className="form-control" id="capacity" placeholder="Capacity" readOnly />
								</div>
							</div>
							<div className="form-group">
								<label className="control-label col-sm-5">Count:</label>
								<div className="col-sm-7">
									<input type="text" className="form-control" id="count" placeholder="Count" onChange={this.machineCountChange} />
								</div>
							</div>
							<div className="form-group">
								<label className="control-label col-sm-5">From Date:</label>
								<div className="col-sm-7">
									<DatePicker id="inp_fromDatePopup"
										className='form-control'
										placeholderText="From Date"
										selected={this.state.startDate2}
										onChange={this.handleStartDate2}
										dateFormat="dd-MM-yyyy"
										//minDate= {this.state.minDate}
										autoComplete='off'
									/>
								</div>
							</div>
							<div className="form-group">
								<label className="control-label col-sm-5">To Date:</label>
								<div className="col-sm-7">
									<DatePicker id="inp_toDatePopup"
										className='form-control'
										placeholderText="To Date"
										selected={this.state.endDate2}
										onChange={this.handleEndDate2}
										dateFormat="dd-MM-yyyy"
										//minDate= {this.state.minDate}
										autoComplete='off'
									/>
								</div>
							</div>
							<div className="form-group" style={{ marginTop: 25 }}>
								<div className="col-sm-12 text-center">
									<button type="button" className="btn btn-warning" id="saveMachine" onClick={this.saveMachine}>Save</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

export default PO;
